import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'alg-agile-info-contract',
  templateUrl: './alg-agile-info-contract.component.html',
  styleUrls: ['./alg-agile-info-contract.component.scss'],
})
export class AlgAgileInfoContractComponent implements OnInit {
  @Input() reverse: boolean;

  public idRichiesta: string;
  public typeRichiesta: string;
  public codeRichiesta: string;
  public temporaryUrl: string;
  public clientPod: string;
  public clientPdr: string;
  public clientPremio: string;
  public clientPremioDetail: string;
  public premioSconto: string;
  public isLight: boolean;
  public isGas: boolean;
  public isDual: boolean;

  constructor(private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.temporaryUrl = window.location.href;
      this.codeRichiesta = params.codice;
      this.typeRichiesta = params.tipo.replace('-', '');
      this.clientPod = params.pod || '';
      this.clientPdr = params.pdr || '';
      this.clientPremio = params.premio || '';
      this.isLight =
        this.temporaryUrl.includes('mono-luce') ||
        this.temporaryUrl.includes('dual');
      this.isGas =
        this.temporaryUrl.includes('mono-gas') ||
        this.temporaryUrl.includes('dual');
      this.isDual = this.isGas && this.isLight;
      if (this.clientPremio === 'buono') {
        this.clientPremioDetail = 'BuonoAgile';
      }
      if (this.clientPremio === 'sconto') {
        this.clientPremioDetail = 'ScontoAgile';
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-agile-info-contract/alg-agile-info-contract.component.ts